import { put ,delay} from 'redux-saga/effects';
import history from "../../../history";
import http from "axios/index";
import i18n from "i18next";

import {
  AUTHENTICATE_USER,
  UPDATE_USER_LANGUAGE,
} from "../../../api/constants";

import {
    setSession,
    verifyToken,
	setLanguage,
    removeSession, getEmployeesSuccessful, getEmployeesFailure
} from '../../actions'

import swal from "sweetalert2";
import {swalOpen} from "../../utils";
import {SWAL_ERROR_TITLE, SWAL_TYPE_ERROR} from "../../../utils/constants";

export function* checkUser({ payload }) {
  try {
    if (payload.code && payload.redirectUrl) {
      var data = new URLSearchParams();
      data.append("code", payload.code);
      data.append("redirectUrl", payload.redirectUrl);
      swal({
        title: "Lütfen bekleyin..",
        text: "Sayfa yükleniyor.",
        showConfirmButton: false,
      }).catch(swal.noop);
      const response = yield http.post(AUTHENTICATE_USER, data);
      const employeeInfo = response.data.data;
      yield put(setSession(employeeInfo));
      yield put(
        verifyToken({
          accessToken: employeeInfo.accessToken,
          sso: employeeInfo.sso,
        })
      );

      history.push("/panel");
    }
  } catch (error) {
    yield put(removeSession());
    console.error("Error happened when try to check User.Error : ", error);
  }
}

export function* changeLanguage({ payload }) {
  try {
    var data = new URLSearchParams();
    data.append("language", payload.language);
    data.append("accessToken", payload.accessToken);
    const response = yield http.post(UPDATE_USER_LANGUAGE, data);
    const language = response.data.data
    i18n.changeLanguage(language)
     yield put(setLanguage(language));
  } catch (error) {
    swal({
      title: "Hata / Error",
      html: "Anlık bir hata nedeniyle dil değişimi saptanmamıştır! <br/> No language change detected due to a momentary error! ",
      showConfirmButton: false,
    }).catch(swal.noop);
  }
}
